module.exports = __webpack_public_path__ + "img/pharmacy-instructions.0c5eb807.png";